import Api from 'services/api/Api';
import pages from 'services/routes/pages';
import { LPO_LINK } from 'services/routes/constants';

const LpoLinkApiFactory = () => {
  const url = pages[LPO_LINK].endpoint;

  return {
    url,
    fetchReport: async (data) => {
      return Api.postRequest(url, data);
    },
  };
};

const DetailAnalyzeApi = LpoLinkApiFactory();
export default DetailAnalyzeApi;
